import { ComponentProps } from "react";

export default function PinIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="size-6"
      {...props}
    >
      <path
        d="M17.122 1.87a3 3 0 0 0-4.666.533L9.61 6.959c-.97-.36-2.638-.755-4.37-.103-1.6.6-2.12 2.49-.598 4.012l3.535 3.535-6.68 6.68a1 1 0 1 0 1.414 1.415l6.68-6.68 3.535 3.535c1.52 1.522 3.413 1.003 4.012-.598.652-1.73.256-3.397-.104-4.368l4.557-2.846A3 3 0 0 0 22.05 6.8z"
        fill="currentColor"
      />
      <path
        d="M14.152 3.462a1 1 0 0 1 1.556-.178l4.928 4.929a1 1 0 0 1-.178 1.555l-4.556 2.845c-.945.59-1.155 1.75-.833 2.62.286.77.514 1.889.107 2.968-.056.147-.136.226-.232.258a.87.87 0 0 1-.63-.267L5.828 9.607a.87.87 0 0 1-.267-.631c.032-.096.111-.176.258-.232 1.08-.407 2.198-.179 2.969.107.869.322 2.03.112 2.62-.833z"
        fill={props.fill}
      />
    </svg>
  );
}
